import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 21 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 12\" id=\"menu\"><path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M3 12h18v-2c-9-.333-15-.333-18 0s-3 1 0 2zm0-5h18V5H3v2zm0-7v2h18V0H3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol